/**
 * 组合框节点（P-A2）：一个带主题色的虚线容器，框住一组成员做视觉归组。
 * 轻量实现——不做 xyflow 父子耦合（成员仍是独立节点），组只记 memberIds + 尺寸 + 颜色，
 * 因此稳、不会因相对坐标把节点弹飞。整框 pointer-events:none 让成员照常可点，
 * 仅顶部标题条可点（用于选中该组以解组/换色）。
 */
import type { NodeProps } from '@xyflow/react';

interface GroupData extends Record<string, unknown> {
  label: string;
  color: string;
  width: number;
  height: number;
  memberCount: number;
}

export function GroupNodeCard({ data, selected }: NodeProps) {
  const d = data as GroupData;
  return (
    <div
      className={`group-frame gc-${d.color} pointer-events-none relative rounded-card border-2 border-dashed`}
      style={{ width: d.width, height: d.height }}
    >
      <span
        className={`group-chip gc-${d.color} pointer-events-auto absolute left-2 top-1.5 cursor-pointer rounded-control px-1.5 py-0.5 text-uiSm font-semibold`}
        style={{ outline: selected ? '1px solid currentColor' : 'none' }}
      >
        {d.label} · {d.memberCount} 项
      </span>
    </div>
  );
}
